// ---------------------------------------------------------------------
// 🔒 AUTOGENERATED @synergy-design-system/react wrappers for @synergy-design-system/components
// Please do not edit this file directly!
// It will get recreated when running pnpm build.
// ---------------------------------------------------------------------
import * as React from 'react';
import { createComponent } from '@lit/react';
import Component from '@synergy-design-system/components/components/tab/tab.component.js';

import { type EventName } from '@lit/react';
import type { SynCloseEvent } from '@synergy-design-system/components';

const tagName = 'syn-tab';
Component.define('syn-tab');

/**
 * @summary Tabs are used inside [tab groups](/components/tab-group) to represent and activate [tab panels](/components/tab-panel).
 * @documentation https://synergy-design-system.github.io/?path=/docs/components-syn-tab--docs
 * @status stable
 * @since 2.0
 *
 * @dependency syn-icon-button
 *
 * @slot - The tab's label.
 *
 * @event syn-close - Emitted when the tab is closable and the close button is activated.
 *
 * @csspart base - The component's base wrapper.
 * @csspart close-button - The close button, an `<syn-icon-button>`.
 * @csspart close-button__base - The close button's exported `base` part.
 */
export const SynTab = createComponent({
  displayName: 'SynTab',
  elementClass: Component,
  events: {
    onSynClose: 'syn-close' as EventName<SynCloseEvent>,
  },
  react: React,
  tagName,
});

export type { SynCloseEvent } from '@synergy-design-system/components';
